import React, { useEffect, useState } from 'react';
import api from '../api/api';

type Publication = { id: number; operatingGroupId: number; expiresAtUtc: string; revokedAtUtc: string | null };

const PublicMenuPublicationPanel: React.FC = () => {
  const [publications, setPublications] = useState<Publication[]>([]);
  const [expiry, setExpiry] = useState('');
  const [link, setLink] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(true);

  useEffect(() => {
    let active = true;
    api.get<Publication[]>('/public-menu-publications')
      .then(({ data }) => { if (active) setPublications(data); })
      .catch(() => { if (active) setError('Не вдалося завантажити публікації поточного ресторану.'); })
      .finally(() => { if (active) setBusy(false); });
    return () => { active = false; };
  }, []);

  const publish = async () => {
    if (!expiry) return;
    setBusy(true);
    setLink('');
    setError('');
    try {
      const { data } = await api.post<{ menuPath: string }>('/public-menu-publications', {
        expiresAtUtc: new Date(expiry).toISOString(),
      });
      setLink(new URL(data.menuPath, window.location.origin).href);
      const response = await api.get<Publication[]>('/public-menu-publications');
      setPublications(response.data);
    } catch {
      setError('Публікацію не підтверджено або стан не оновився. Перезавантажте сторінку перед повторною дією.');
    } finally {
      setBusy(false);
    }
  };

  const revoke = async (id: number) => {
    setBusy(true);
    setError('');
    try {
      await api.delete(`/public-menu-publications/${id}`);
      setLink('');
      setPublications(current => current.map(item => item.id === id
        ? { ...item, revokedAtUtc: new Date().toISOString() } : item));
    } catch {
      setError('Не вдалося відкликати публікацію. Перевірте актуальний стан.');
    } finally {
      setBusy(false);
    }
  };

  return <section aria-labelledby="public-menu-title">
    <h3 id="public-menu-title">Публічне меню поточного ресторану</h3>
    <p>Публікуються лише власні затверджені позиції. Нова публікація відкликає попереднє посилання
      та сеанси гостей. Власні активні QR-коди працюють лише за чинної публікації.
      Історичні дані HALLS спочатку потребують контрольованого призначення власника.</p>
    <label>Чинне до (місцевий час)
      <input type="datetime-local" value={expiry} onChange={event => setExpiry(event.target.value)}
        style={{ minHeight: 44, fontSize: 16 }} />
    </label>{' '}
    <button type="button" disabled={busy || !expiry} onClick={() => void publish()} style={{ minHeight: 44 }}>
      Опублікувати / замінити посилання
    </button>
    {error && <p role="alert">{error}</p>}
    {link && <p role="status">Збережіть нове посилання (показується лише зараз): <a href={link}>{link}</a></p>}
    {publications.map(item => <p key={item.id}>
      #{item.id}, ресторан #{item.operatingGroupId}: {item.revokedAtUtc ? 'Відкликано'
        : `Чинне до ${new Date(item.expiresAtUtc).toLocaleString('uk-UA')}`}{' '}
      {!item.revokedAtUtc && <button type="button" disabled={busy} onClick={() => void revoke(item.id)}
        style={{ minHeight: 44 }}>Відкликати публікацію #{item.id}</button>}
    </p>)}
  </section>;
};

export default PublicMenuPublicationPanel;
